import { IAPIResponse } from "../Services/AjaxService";
import ApiService from "../Services/ApiService";
import { Decript } from "./Cripto";

export const JSONPrint = (jsonString: any) => {
  return (
    <div
      style={{
        whiteSpace: "pre",
        maxHeight: "15em",
        overflow: "auto",
        border: "1px solid rgba(0,0,0,0.1)",
        padding: "1em",
        background: "white",
        width: "fit-content",
      }}
    >
      {!jsonString && <div>No data</div>}
      {jsonString && JSON.stringify(jsonString, null, 4)}
    </div>
  );
};

var restoringSession: boolean = false;
export const refreshToken = async () => {
  if (restoringSession) {
    return "wait";
  }
  restoringSession = true;

  let autocreds = localStorage.getItem("autologin");
  if (autocreds) {
    let creds = JSON.parse(autocreds);
    let uname = creds.user;
    let upassword = Decript(creds.token);
    let response: IAPIResponse = await ApiService.SessionController.Login(
      uname,
      upassword
    );

    if (response.error === null) {
      localStorage.setItem("sessionToken", response.parsed.token);
      restoringSession = false;
      return "yes";
    }
  }
  restoringSession = false;
  return "no";
};
